import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';

import { Logger } from '@app/core/logger.service';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { ActivatedRouteSnapshot } from '@angular/router';
import { RouterStateSnapshot } from '@angular/router';

import { routesConstants } from '@app/shared/models/LinksView';
import { default as constantsFile } from '@app/shared/constants.json';

const log = new Logger('AuthenticationGuard');

@Injectable()
export class AuthenticationGuard implements CanActivate
{
	constants: any = constantsFile.constants;

  constructor(private router: Router,
              private authenticationService: AuthenticationService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.authenticationService.isAuthenticated())
    {
      log.debug("Guard " + route.url + " Authenticated" );
      if(state.url == '/') {
      	const user = this.authenticationService.credentials;
      	if(user?.roleName.includes(this.constants.roleNames.premium)) {
          log.debug('Premium user, redirecting to analytics...');
          this.router.navigate([routesConstants.analytics]);
        } else if (user?.roleName.includes(this.constants.roleNames.airline) || user?.roleName.includes(this.constants.roleNames.airlineplus)) {
            log.debug('Airline user, redirecting to charts...');
            this.router.navigate([routesConstants.charts]);
        } else if (user?.roleName.includes(this.constants.roleNames.admin)) {
            log.debug('Admin user, redirecting to support...');
            this.router.navigate([routesConstants.communications.communications]);
        } else {
          log.debug('User, redirecting to charts...');
          this.router.navigate([routesConstants.charts]);
        }
      }
      return true;
    }

    log.debug('Not authenticated, redirecting...');
    this.router.navigate([routesConstants.landing], { queryParams: { returnUrl: state.url != '/' ? state.url : routesConstants.charts }});
    return false;
  }
}
